/* ==========================================================================
   thas.cosmetics — interactividad propia
   Un solo archivo. Cada init es idempotente (marca el elemento con
   data-th-init) para poder re-ejecutarse cuando el editor de Shopify
   vuelve a pintar una seccion sin recargar la pagina.
   ========================================================================== */
(function () {
  if (window.__thasInit) return;
  window.__thasInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Reveals al entrar en pantalla ------------------------------------- */
  var revealObserver = null;

  function initReveals(root) {
    var nodes = (root || document).querySelectorAll('.th-reveal');
    if (!nodes.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        el.classList.add('th-visible');
      });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('th-visible');
            revealObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
    }

    nodes.forEach(function (el) {
      if (el.dataset.thInit) return;
      el.dataset.thInit = '1';
      revealObserver.observe(el);
    });

    // Red de seguridad: si el observer no dispara, mostrar todo igualmente.
    window.setTimeout(function () {
      nodes.forEach(function (el) {
        el.classList.add('th-visible');
      });
    }, 1600);
  }

  /* --- Carrusel de productos --------------------------------------------- */
  function initCarruseles(root) {
    var carruseles = (root || document).querySelectorAll('[data-th-car]');

    carruseles.forEach(function (car) {
      if (car.dataset.thInit) return;
      car.dataset.thInit = '1';

      var wrap = car.querySelector('.th-car__wrap');
      var prev = car.querySelector('[data-th-prev]');
      var next = car.querySelector('[data-th-next]');
      if (!wrap) return;

      function paso() {
        var card = wrap.querySelector('.th-card');
        if (!card) return wrap.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(wrap.firstElementChild).gap) || 16;
        var visibles = Math.max(1, Math.floor(wrap.clientWidth / (card.offsetWidth + gap)));
        return (card.offsetWidth + gap) * visibles;
      }

      function refrescar() {
        if (!prev || !next) return;
        var max = wrap.scrollWidth - wrap.clientWidth - 2;
        prev.disabled = wrap.scrollLeft <= 2;
        next.disabled = wrap.scrollLeft >= max;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          wrap.scrollBy({ left: -paso(), behavior: reduce ? 'auto' : 'smooth' });
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          wrap.scrollBy({ left: paso(), behavior: reduce ? 'auto' : 'smooth' });
        });
      }

      wrap.addEventListener('scroll', refrescar, { passive: true });
      window.addEventListener('resize', refrescar);
      refrescar();
    });
  }

  /* --- FAQ desplegable ---------------------------------------------------- */
  function initFaq(root) {
    var botones = (root || document).querySelectorAll('[data-th-faq-q]');

    botones.forEach(function (btn) {
      if (btn.dataset.thInit) return;
      btn.dataset.thInit = '1';

      btn.addEventListener('click', function () {
        var abierto = btn.getAttribute('aria-expanded') === 'true';
        var lista = btn.closest('[data-th-faq]');

        if (lista && lista.dataset.thSolo === 'true' && !abierto) {
          lista.querySelectorAll('[data-th-faq-q]').forEach(function (otro) {
            otro.setAttribute('aria-expanded', 'false');
          });
        }

        btn.setAttribute('aria-expanded', abierto ? 'false' : 'true');
      });
    });
  }

  /* --- Aviso de bienvenida ------------------------------------------------ */
  function initAviso(root) {
    var avisos = (root || document).querySelectorAll('[data-th-aviso]');

    avisos.forEach(function (aviso) {
      if (aviso.dataset.thInit) return;
      aviso.dataset.thInit = '1';

      var clave = 'thas-aviso-' + (aviso.dataset.thVersion || '1');
      var editor = document.documentElement.classList.contains('shopify-design-mode');
      var repetir = aviso.dataset.thRepetir === 'true';
      var espera = parseInt(aviso.dataset.thEspera || '900', 10);

      function cerrar() {
        aviso.classList.remove('th-aviso--on');
        document.body.style.overflow = '';
        try {
          if (!repetir) window.localStorage.setItem(clave, '1');
        } catch (e) {
          /* navegacion privada: no pasa nada, se volvera a ver */
        }
      }

      function abrir() {
        aviso.classList.add('th-aviso--on');
        document.body.style.overflow = 'hidden';
      }

      aviso.querySelectorAll('[data-th-cerrar]').forEach(function (btn) {
        btn.addEventListener('click', cerrar);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && aviso.classList.contains('th-aviso--on')) cerrar();
      });

      // En el editor se muestra siempre para que el usuario pueda verlo.
      if (editor) {
        abrir();
        return;
      }

      var visto = false;
      try {
        visto = window.localStorage.getItem(clave) === '1';
      } catch (e) {
        visto = false;
      }

      if (visto && !repetir) return;
      window.setTimeout(abrir, espera);
    });
  }

  /* --- Marquesina: bucle continuo -----------------------------------------
     No basta con duplicar la pista una vez: si los mensajes ocupan menos que
     el ancho de la pantalla, al desplazarse queda un HUECO VACÍO. Hay que
     repetir los mensajes hasta superar el ancho visible y, sólo entonces,
     clonar la pista entera para el bucle. */
  function initTiras(root) {
    var tiras = (root || document).querySelectorAll('[data-th-tira]');

    tiras.forEach(function (tira) {
      if (tira.dataset.thInit) return;
      tira.dataset.thInit = '1';

      // La banda de texto usa .th-tira__track y la tira de reseñas
      // .th-res__track: el mecanismo de duplicado es el mismo.
      var track = tira.querySelector('.th-tira__track, .th-res__track, .th-mini__track');
      if (!track) return;
      var claseTrack = track.className.split(/\s+/).filter(Boolean)
        .map(function (x) { return '.' + x; }).join('');

      var originales = [].slice.call(track.children);
      if (!originales.length) return;

      function rellenar() {
        // limpiar lo añadido en pasadas anteriores
        tira.querySelectorAll(claseTrack + '[aria-hidden="true"]').forEach(function (c) {
          c.parentNode.removeChild(c);
        });
        while (track.children.length > originales.length) {
          track.removeChild(track.lastChild);
        }

        var visible = tira.clientWidth || window.innerWidth || 1200;
        var vueltas = 0;
        while (track.scrollWidth < visible && vueltas < 25) {
          originales.forEach(function (n) {
            track.appendChild(n.cloneNode(true));
          });
          vueltas++;
        }

        var copia = track.cloneNode(true);
        copia.setAttribute('aria-hidden', 'true');
        tira.appendChild(copia);
      }

      rellenar();

      var espera;
      window.addEventListener('resize', function () {
        window.clearTimeout(espera);
        espera = window.setTimeout(rellenar, 250);
      });
    });
  }

  /* --- Ficha de producto: jerarquía de botones ----------------------------
     El fondo de estos botones lo fija una hoja de estilos a la que no se
     puede llegar desde CSS (ni con !important). Se pone en línea, que gana
     siempre. Los colores se leen de las variables del tema para que sigan
     siendo editables desde el editor. */
  function initBotonesProducto(root) {
    var main = document.querySelector('main[data-template^="product"]');
    if (!main) return;

    var estilos = getComputedStyle(document.documentElement);
    var rosa = (estilos.getPropertyValue('--th-rose') || '#ff99cc').trim();
    var vino = '#3d0f27';
    var tinta = (estilos.getPropertyValue('--th-ink') || '#1a1418').trim();

    function pintar(el, fondo, texto, borde) {
      el.style.setProperty('background-color', fondo, 'important');
      el.style.setProperty('color', texto, 'important');
      el.style.setProperty('border-color', borde, 'important');
    }

    // En esta tienda el rosa SIGNIFICA "en stock". Así que el botón solo se
    // pinta de rosa si el producto está en stock; si es por encargue se queda
    // en el tono neutro, igual que en las tarjetas del catálogo.
    var enStock = !!document.querySelector('.th-modalidad--stock');

    main.querySelectorAll('.add-to-cart-button').forEach(function (el) {
      if (el.dataset.thBtn) return;
      el.dataset.thBtn = '1';
      if (enStock) {
        pintar(el, rosa, vino, rosa);
      } else {
        pintar(el, tinta, '#ffffff', tinta);
      }
      el.style.setProperty('font-weight', '600', 'important');
    });

    // Aviso de la app de reposición: venía rosa sobre gris (ilegible). Los
    // colores los pone la app en línea Y los pinta DESPUÉS de que corra este
    // script, así que hace falta vigilar el DOM hasta que aparezca.
    function arreglarAviso() {
      var cajas = main.querySelectorAll('.restock-rocket-preorder-description');
      var hecho = false;
      cajas.forEach(function (el) {
        hecho = true;
        if (el.dataset.thAviso) return;
        el.dataset.thAviso = '1';
        el.style.setProperty('background-color', 'rgba(255,153,204,.13)', 'important');
        el.style.setProperty('color', tinta, 'important');
        el.querySelectorAll('*').forEach(function (h) {
          h.style.setProperty('color', tinta, 'important');
        });
      });
      return hecho;
    }

    if (!main.dataset.thVigilaAviso) {
      main.dataset.thVigilaAviso = '1';
      arreglarAviso();
      var observador = new MutationObserver(function () {
        arreglarAviso();
      });
      observador.observe(main, { childList: true, subtree: true });
      // No hace falta vigilar para siempre: la app pinta en los primeros segundos.
      window.setTimeout(function () {
        observador.disconnect();
      }, 15000);
    }

    // Secundario: WhatsApp, en contorno para que no compita
    main.querySelectorAll('a[href*="wa.me"]').forEach(function (el) {
      if (el.dataset.thBtn) return;
      if (el.className.indexOf('button') === -1) return;
      el.dataset.thBtn = '1';
      pintar(el, 'transparent', tinta, 'rgba(26,20,24,.3)');
      el.style.setProperty('border-width', '1.5px', 'important');
      el.style.setProperty('border-style', 'solid', 'important');
    });
  }

  /* --- Combo: añade los dos productos y aplica el descuento --------------- */
  function initCombo(root) {
    (root || document).querySelectorAll('[data-th-combo]').forEach(function (caja) {
      if (caja.dataset.thInit) return;
      caja.dataset.thInit = '1';

      // Modo compacto: el combo se muda a la zona de compra, justo encima del
      // botón de agregar al carrito. Se mueve el <section> entero para no
      // romper las referencias internas, y sus estilos van por CLASE (no por
      // el id de la sección) precisamente para que sobreviva a la mudanza.
      if (caja.dataset.thUbicacion === 'compra') {
        var main = document.querySelector('main[data-template^="product"]');
        // ⚠️ Antes se insertaba junto a `.product-form-buttons`, y eso dejaba
        // la sección DENTRO del <form> de compra. Horizon vuelve a dibujar ese
        // formulario al cambiar de variante, así que según quién llegara
        // primero el botón «Agregar al carrito» se quedaba sin responder: se
        // tocaba y no pasaba nada. Solo fallaba en fichas con pack, y de forma
        // intermitente, porque es una carrera.
        // El formulario solo envuelve los botones y unos campos ocultos (el
        // selector de tonos queda fuera), así que insertando el pack JUSTO
        // ANTES del form se ve exactamente en el mismo sitio pero ya no queda
        // dentro.
        var formCompra = main && main.querySelector('form[action*="/cart/add"]');
        var destino = formCompra || (main && main.querySelector('.product-form-buttons'));
        if (destino && destino.parentElement) {
          destino.parentElement.insertBefore(caja, destino);
        }
      }

      var selects = [].slice.call(caja.querySelectorAll('[data-th-combo-variante]'));
      var boton = caja.querySelector('[data-th-combo-add]');
      var etiqueta = caja.querySelector('[data-th-combo-label]');
      var totalNormal = caja.querySelector('[data-th-total-normal]');
      var totalCombo = caja.querySelector('[data-th-total-combo]');
      var codigo = (caja.dataset.thCodigo || '').trim();
      var ahorroCent = parseInt(caja.dataset.thAhorro || '0', 10) * 100;
      var textoOriginal = etiqueta ? etiqueta.textContent : '';

      function pesos(centavos) {
        var n = centavos / 100;
        try {
          return '$' + n.toLocaleString('es-UY', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        } catch (e) {
          return '$' + n.toFixed(2);
        }
      }

      function recalcular() {
        var suma = 0;
        selects.forEach(function (sel) {
          var op = sel.options[sel.selectedIndex];
          var precio = op ? parseInt(op.dataset.precio || '0', 10) : 0;
          suma += precio;

          var item = sel.closest('.th-combo__item');
          if (!item) return;

          var unidad = item.querySelector('[data-th-precio-unidad]');
          if (unidad) unidad.textContent = pesos(precio);

          // Cambiar la foto al tono elegido, con un fundido corto
          var caja = item.querySelector('[data-th-combo-foto]');
          var img = caja && caja.querySelector('img');
          var nueva = op && op.dataset.imagen;
          if (img && nueva && img.getAttribute('src') !== nueva) {
            caja.classList.add('th-cambiando');
            var previa = new Image();
            previa.onload = function () {
              img.src = nueva;
              caja.classList.remove('th-cambiando');
            };
            previa.onerror = function () {
              caja.classList.remove('th-cambiando');
            };
            previa.src = nueva;
          }
        });
        var final = Math.max(0, suma - ahorroCent);
        if (totalNormal) totalNormal.textContent = pesos(suma);
        if (totalCombo) totalCombo.textContent = pesos(final);
        var precioBtn = caja.querySelector('[data-th-combo-precio-btn]');
        if (precioBtn) precioBtn.textContent = pesos(final);
      }

      selects.forEach(function (sel) {
        sel.addEventListener('change', recalcular);
      });
      recalcular();

      if (!boton) return;

      boton.addEventListener('click', function () {
        var items = [];
        var faltaStock = false;

        selects.forEach(function (sel) {
          var op = sel.options[sel.selectedIndex];
          if (!op || op.disabled) {
            faltaStock = true;
            return;
          }
          items.push({ id: parseInt(op.value, 10), quantity: 1 });
        });

        if (faltaStock || items.length < selects.length) {
          if (etiqueta) etiqueta.textContent = 'Elegí una opción disponible';
          window.setTimeout(function () {
            if (etiqueta) etiqueta.textContent = textoOriginal;
          }, 2600);
          return;
        }

        boton.disabled = true;
        if (etiqueta) etiqueta.textContent = 'Agregando...';

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart');
            return res.json();
          })
          .then(function () {
            // /discount/CODIGO aplica el código y devuelve al carrito ya con él.
            if (codigo) {
              window.location.href = '/discount/' + encodeURIComponent(codigo) + '?redirect=/cart';
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function () {
            boton.disabled = false;
            if (etiqueta) etiqueta.textContent = 'No se pudo agregar, probá de nuevo';
            window.setTimeout(function () {
              if (etiqueta) etiqueta.textContent = textoOriginal;
            }, 3000);
          });
      });
    });
  }

  /* --- Distintivo en la rejilla de colección ------------------------------
     La rejilla de Horizon no es nuestra, así que el distintivo se añade desde
     aquí. La lista de "en stock" la calcula Liquid desde las COLECCIONES; la
     app de reposición usaba el inventario y marcaba "Encargar" productos que
     sí estaban en stock. */
  function initEtiquetasRejilla(root) {
    var datos = document.querySelector('[data-th-stock-lista]');
    if (!datos) return;

    var enStock = (datos.getAttribute('data-th-stock-lista') || '')
      .split(',')
      .map(function (h) {
        return h.trim();
      })
      .filter(Boolean);

    if (!enStock.length) return;

    var txtStock = datos.getAttribute('data-th-texto-stock') || 'En stock';
    var txtEnc = datos.getAttribute('data-th-texto-encargue') || 'Por encargue';

    function etiquetar(card) {
      // ⚠️ Se comprueba si la etiqueta ESTÁ, no una marca en el dataset: cuando
      // Horizon vuelve a dibujar la rejilla (filtros, ordenar, cambiar de
      // vista, cargar más) reemplaza las tarjetas y la etiqueta se pierde. Con
      // una marca en el dataset la tarjeta se daba por hecha y se quedaba sin
      // cartel.
      if (card.querySelector('.th-badge--rejilla')) return;
      if (card.closest('.th-section')) return; // las nuestras ya la traen

      var enlace = card.querySelector('a[href*="/products/"]');
      if (!enlace) return;

      var href = enlace.getAttribute('href') || '';
      var trozo = href.split('/products/')[1];
      if (!trozo) return;
      var handle = trozo.split('?')[0].split('#')[0].replace(/\/$/, '');

      var galeria = card.querySelector('.card-gallery') || card.firstElementChild;
      if (!galeria) return;

      var hay = enStock.indexOf(handle) !== -1;
      var etiqueta = document.createElement('span');
      etiqueta.className = 'th-badge th-badge--rejilla ' + (hay ? 'th-badge--stock' : 'th-badge--encargue');
      etiqueta.innerHTML = (hay ? '<span class="th-badge__dot"></span>' : '') + (hay ? txtStock : txtEnc);

      if (getComputedStyle(galeria).position === 'static') {
        galeria.style.position = 'relative';
      }
      galeria.appendChild(etiqueta);
    }

    function repasar(zona) {
      (zona || document).querySelectorAll('product-card, .product-card').forEach(etiquetar);
    }

    repasar(root);

    // Un solo observador para toda la página: cualquier tarjeta que aparezca
    // más tarde recibe su cartel. Cubre paginación, filtros y carga diferida
    // sin depender de qué evento dispare cada tema.
    if (!document.body.dataset.thObsRejilla) {
      document.body.dataset.thObsRejilla = '1';
      var pendiente = null;
      new MutationObserver(function () {
        window.clearTimeout(pendiente);
        pendiente = window.setTimeout(function () { repasar(document); }, 120);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  /* --- Precio pagando por transferencia -----------------------------------
     Se inserta debajo del precio, dentro del bloque de compra de Horizon
     (ahí no se puede meter Liquid propio). Se recalcula al cambiar de
     variante, que es cuando Horizon reescribe el precio. */
  function initPrecioTransferencia(root) {
    var datos = document.querySelector('[data-th-transferencia]');
    if (!datos) return;

    var main = document.querySelector('main[data-template^="product"]');
    if (!main) return;

    var pct = parseFloat(datos.getAttribute('data-th-pct') || '0');
    if (!pct) return;

    var texto = datos.getAttribute('data-th-texto') || 'pagando por transferencia';
    var nota = datos.getAttribute('data-th-nota') || '';

    var bloquePrecio = main.querySelector('product-price');
    if (!bloquePrecio) return;

    function aNumero(txt) {
      // "$1.570,00" → 1570.00  (puntos = miles, coma = decimales)
      var limpio = String(txt).replace(/[^\d.,]/g, '').replace(/\./g, '').replace(',', '.');
      var n = parseFloat(limpio);
      return isNaN(n) ? null : n;
    }

    function aPesos(n) {
      try {
        return '$' + n.toLocaleString('es-UY', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } catch (e) {
        return '$' + n.toFixed(2);
      }
    }

    function pintar() {
      var span = bloquePrecio.querySelector('.price, [class*="price"]');
      var base = aNumero(span ? span.textContent : bloquePrecio.textContent);
      if (base === null || base <= 0) return;

      var conDescuento = base * (1 - pct / 100);

      var caja = bloquePrecio.parentElement.querySelector('.th-transfer');
      if (!caja) {
        caja = document.createElement('p');
        caja.className = 'th-transfer';
        caja.innerHTML =
          '<span class="th-transfer__linea"><b class="th-transfer__precio"></b><span class="th-transfer__texto"></span></span>' +
          '<span class="th-transfer__nota"></span>';
        bloquePrecio.insertAdjacentElement('afterend', caja);
      }

      caja.querySelector('.th-transfer__precio').textContent = aPesos(conDescuento);
      caja.querySelector('.th-transfer__texto').textContent = ' ' + texto;
      var elNota = caja.querySelector('.th-transfer__nota');
      elNota.textContent = nota;
      elNota.style.display = nota ? '' : 'none';
    }

    pintar();

    if (!bloquePrecio.dataset.thTransfer) {
      bloquePrecio.dataset.thTransfer = '1';
      var obs = new MutationObserver(function () {
        pintar();
      });
      obs.observe(bloquePrecio, { childList: true, subtree: true, characterData: true });
    }
  }

  /* --- Banner principal: rotación de imágenes ----------------------------- */
  function initHero(root) {
    (root || document).querySelectorAll('[data-th-hero]').forEach(function (hero) {
      if (hero.dataset.thInit) return;
      hero.dataset.thInit = '1';

      var slides = [].slice.call(hero.querySelectorAll('[data-th-slide]'));
      if (slides.length < 2) return;

      var puntos = [].slice.call(hero.querySelectorAll('[data-th-hero-punto]'));
      var segundos = parseInt(hero.dataset.thAuto, 10);
      if (isNaN(segundos)) segundos = 6;

      var actual = 0;
      var reloj = null;

      function mostrar(i) {
        actual = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          s.classList.toggle('th-hero__slide--activa', n === actual);
        });
        puntos.forEach(function (p, n) {
          p.classList.toggle('th-hero__punto--activo', n === actual);
          p.setAttribute('aria-current', n === actual ? 'true' : 'false');
        });
      }

      function arrancar() {
        parar();
        if (!segundos) return;
        // Ojo: NO se corta por `prefers-reduced-motion`. Quien tenga las
        // animaciones desactivadas en su sistema se quedaba sin carrusel
        // entero. El respeto a esa preferencia se hace en el CSS, quitando
        // el fundido y el zoom: cambia igual, pero de golpe.
        reloj = window.setInterval(function () {
          mostrar(actual + 1);
        }, segundos * 1000);
      }

      function parar() {
        if (reloj) window.clearInterval(reloj);
        reloj = null;
      }

      puntos.forEach(function (p) {
        p.addEventListener('click', function () {
          mostrar(parseInt(p.dataset.thHeroPunto, 10) || 0);
          arrancar();
        });
      });

      // Se pausa SOLO encima de los controles (puntitos y botones). Antes se
      // pausaba con el ratón sobre el banner entero y, como ocupa casi toda
      // la pantalla, el puntero estaba encima prácticamente siempre: el
      // carrusel parecía roto.
      hero
        .querySelectorAll('.th-hero__puntos, .th-hero__cta')
        .forEach(function (zona) {
          zona.addEventListener('mouseenter', parar);
          zona.addEventListener('mouseleave', arrancar);
        });
      hero.addEventListener('focusin', parar);
      hero.addEventListener('focusout', arrancar);

      // No malgastar temporizador mientras el banner no se ve.
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) parar();
        else arrancar();
      });

      // En el editor de temas, al seleccionar un bloque hay que mostrarlo.
      hero.thMostrar = mostrar;
      hero.thParar = parar;
      hero.thArrancar = arrancar;

      mostrar(0);
      arrancar();
    });
  }

  function heroDeBloque(evento) {
    var hero = evento.target && evento.target.closest
      ? evento.target.closest('[data-th-hero]')
      : null;
    if (!hero || !hero.thMostrar) return null;
    var slides = [].slice.call(hero.querySelectorAll('[data-th-slide]'));
    return { hero: hero, indice: slides.indexOf(evento.target) };
  }

  document.addEventListener('shopify:block:select', function (e) {
    var r = heroDeBloque(e);
    if (!r || r.indice < 0) return;
    r.hero.thMostrar(r.indice);
    r.hero.thParar();
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var r = heroDeBloque(e);
    if (r) r.hero.thArrancar();
  });

  /* --- Aviso de plazo según la VARIANTE elegida ---------------------------
     Un producto de «En Stock» puede tener un tono agotado. Antes se miraba
     solo la colección, así que el cartel seguía diciendo «sale en 48 horas»
     aunque esa variante hubiera que encargarla. */
  function initModalidad(root) {
    (root || document).querySelectorAll('[data-th-modalidad]').forEach(function (grupo) {
      if (grupo.dataset.thInit) return;
      grupo.dataset.thInit = '1';

      var mapa = {};
      (grupo.dataset.thVariantes || '').split('|').forEach(function (par) {
        if (!par) return;
        var t = par.split(':');
        mapa[t[0]] = t[1];
      });

      var cajas = [].slice.call(grupo.querySelectorAll('[data-th-modo]'));
      if (!cajas.length) return;

      function pintar(id) {
        var modo = mapa[String(id)];
        if (!modo) return;
        cajas.forEach(function (c) {
          c.hidden = c.dataset.thModo !== modo;
        });

        // ⚠️ Stoq da por agotadas variantes que SÍ tienen stock: su
        // configuración llega sin el inventario de algunas y por defecto las
        // marca como agotadas. Verificado en Rhode Lip Tint «Toast», que tiene
        // 1 unidad y aun así mostraba «está agotado, reservalo».
        // Aquí ya sabemos la modalidad REAL de la variante elegida, así que su
        // aviso se esconde solo cuando de verdad hay stock, y se recalcula en
        // cada cambio de variante.
        // ⚠️ Es una CARRERA: unas veces el script de Stoq llega antes de que
        // el tema termine y otras no. Cuando llega y cree que la variante es
        // de preventa, mete su recuadro Y ESCONDE el botón «Comprar ahora».
        // De ahí que al usuario le saliera distinto según la recarga.
        var stockReal = modo === 'stock';
        ['restock-rocket'].forEach(function (id) {
          var el = document.getElementById(id);
          if (el) el.style.display = stockReal ? 'none' : '';
        });
        document.querySelectorAll('.restock-rocket-preorder-description').forEach(function (el) {
          el.style.display = stockReal ? 'none' : '';
        });
        // Stoq esconde el pago rápido en línea; si hay stock hay que devolverlo.
        if (stockReal) {
          document.querySelectorAll('.shopify-payment-button').forEach(function (el) {
            if (el.style.display === 'none') el.style.removeProperty('display');
            el.removeAttribute('hidden');
          });
        }
      }

      // El campo `name="id"` del formulario lo actualiza el tema en cuanto
      // cambia la variante: es la señal más fiable, y no depende de qué
      // eventos propios dispare cada tema.
      function campoId() {
        return document.querySelector('form[action*="/cart/add"] [name="id"]');
      }

      var ultimo = null;
      function revisar() {
        var campo = campoId();
        if (!campo) return;
        if (campo.value !== ultimo) {
          ultimo = campo.value;
          pintar(ultimo);
        }
      }

      revisar();
      document.addEventListener('change', revisar, true);
      document.addEventListener('click', function () {
        window.setTimeout(revisar, 60);
      }, true);

      // Red de seguridad: algunos temas cambian la variante sin eventos que
      // burbujeen (por URL, o reescribiendo el formulario entero).
      var campo = campoId();
      if (campo && window.MutationObserver) {
        new MutationObserver(revisar).observe(campo, { attributes: true, attributeFilter: ['value'] });
      }
      window.addEventListener('popstate', revisar);
    });
  }

  /* --- Visor de fotos a pantalla completa ---------------------------------
     La prueba social solo convence si se puede mirar de cerca: en una tira
     de 260 px no se lee lo que dicen las fotos. */
  var visor = null;

  function crearVisor() {
    if (visor) return visor;

    var caja = document.createElement('div');
    caja.className = 'th-visor';
    caja.setAttribute('role', 'dialog');
    caja.setAttribute('aria-modal', 'true');
    caja.setAttribute('aria-label', 'Foto de una clienta');
    caja.innerHTML =
      '<img alt="">' +
      '<button class="th-visor__btn th-visor__cerrar" type="button" aria-label="Cerrar">' +
      '<svg viewBox="0 0 20 20" fill="none"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
      '<button class="th-visor__btn th-visor__prev" type="button" aria-label="Anterior">' +
      '<svg viewBox="0 0 20 20" fill="none"><path d="M12.5 4l-6 6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<button class="th-visor__btn th-visor__next" type="button" aria-label="Siguiente">' +
      '<svg viewBox="0 0 20 20" fill="none"><path d="M7.5 4l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    document.body.appendChild(caja);

    visor = {
      caja: caja,
      img: caja.querySelector('img'),
      lista: [],
      i: 0,
      abridor: null,
    };

    function mostrar(i) {
      visor.i = (i + visor.lista.length) % visor.lista.length;
      visor.img.src = visor.lista[visor.i];
    }
    function cerrar() {
      caja.classList.remove('th-visor--on');
      document.body.style.overflow = '';
      if (visor.abridor) visor.abridor.focus();
    }

    visor.mostrar = mostrar;
    visor.cerrar = cerrar;

    caja.querySelector('.th-visor__cerrar').addEventListener('click', cerrar);
    caja.querySelector('.th-visor__prev').addEventListener('click', function () { mostrar(visor.i - 1); });
    caja.querySelector('.th-visor__next').addEventListener('click', function () { mostrar(visor.i + 1); });
    caja.addEventListener('click', function (e) { if (e.target === caja) cerrar(); });

    document.addEventListener('keydown', function (e) {
      if (!caja.classList.contains('th-visor--on')) return;
      if (e.key === 'Escape') cerrar();
      if (e.key === 'ArrowLeft') mostrar(visor.i - 1);
      if (e.key === 'ArrowRight') mostrar(visor.i + 1);
    });

    return visor;
  }

  function initGaleria(root) {
    (root || document).querySelectorAll('[data-th-res-galeria]').forEach(function (zona) {
      // ⚠️ Marcador PROPIO: esta zona es la misma que la de la marquesina, y
      // `initTiras` ya le pone `data-th-init`. Con el marcador compartido,
      // la galería se saltaba siempre y el clic no hacía nada.
      if (zona.dataset.thInitGaleria) return;
      zona.dataset.thInitGaleria = '1';

      zona.addEventListener('click', function (e) {
        var boton = e.target.closest('[data-th-foto]');
        if (!boton) return;
        e.preventDefault();

        var v = crearVisor();
        // Solo la pista original: la copia del bucle repetiría las fotos.
        var pista = zona.querySelector('.th-res__track:not([aria-hidden="true"])') || zona;
        var botones = [].slice.call(pista.querySelectorAll('[data-th-foto]'));
        v.lista = botones.map(function (b) { return b.dataset.thFoto; });

        var idx = botones.indexOf(boton);
        if (idx < 0) idx = v.lista.indexOf(boton.dataset.thFoto);
        v.abridor = boton;
        v.mostrar(idx < 0 ? 0 : idx);
        v.caja.classList.add('th-visor--on');
        document.body.style.overflow = 'hidden';
        v.caja.querySelector('.th-visor__cerrar').focus();
      });
    });
  }

  /* --- Arranque ----------------------------------------------------------- */
  function initTodo(evento) {
    var root = evento && evento.target && evento.target.querySelector ? evento.target : document;
    initReveals(root);
    initHero(root);
    initCarruseles(root);
    initFaq(root);
    initAviso(root);
    initTiras(root);
    initBotonesProducto(root);    
    initFixBotonesStock();
    initCombo(root);
    initEtiquetasRejilla(root);
    initPrecioTransferencia(root);
    initModalidad(root);
    initGaleria(root);
    initBotonEncargar(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initTodo();
    });
  } else {
    initTodo();
  }

  document.addEventListener('shopify:section:load', initTodo);


  /* --- Color del botón «Encargar» ----------------------------------------
     El TEXTO y la clase ya los pone el servidor, así que no hay parpadeo.
     El COLOR no se puede: Stoq escribe un estilo EN LÍNEA marcado como
     importante con el negro del tema, y eso le gana a cualquier CSS por
     mucho !important que lleve. Solo se puede corregir desde JS.
     Se usan los colores que la propia app tiene configurados: gris #747474
     con letras rosadas #ff99cc.
     ⚠️ Ese par da contraste 2,38 y el mínimo legible es 4,5. Se respeta
     porque es la configuración elegida; con letras blancas serían 4,67.  */
  function initBotonEncargar(root) {
    var FONDO = 'rgb(116, 116, 116)';
    var botones = (root || document).querySelectorAll('.th-boton-encargar');
    if (!botones.length) return;

    function pintar(b) {
      // Guarda contra el bucle: escribir el estilo vuelve a disparar al observador.
      if (b.style.backgroundColor === FONDO) return;
      b.style.setProperty('background-color', '#747474', 'important');
      b.style.setProperty('border-color', '#747474', 'important');
      b.style.setProperty('color', '#ff99cc', 'important');
    }

    var obs = new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) pintar(ms[i].target);
    });

    Array.prototype.forEach.call(botones, function (b) {
      if (b.dataset.thEncargar) return;
      b.dataset.thEncargar = '1';
      pintar(b);
      obs.observe(b, { attributes: true, attributeFilter: ['style'] });
    });
  }
  /* --- Fix: re-sincronizar botón de compra al cargar la página ----------- */
  function initFixBotonesStock() {
    if (document.body.dataset.thFixBtn) return;
    document.body.dataset.thFixBtn = '1';

    var main = document.querySelector('main[data-template^="product"]');
    if (!main) return;

    window.setTimeout(function () {
      var variantPicker = main.querySelector('variant-picker');
      if (!variantPicker) return;

      var checkedInput = variantPicker.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 600);
  }
})();